export default "__VITE_ASSET__86PSWnYY__"